import { render, staticRenderFns } from "./page-head.vue?vue&type=template&id=ce244a10&scoped=true"
import script from "./page-head.vue?vue&type=script&lang=js"
export * from "./page-head.vue?vue&type=script&lang=js"
import style0 from "./page-head.vue?vue&type=style&index=0&id=ce244a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce244a10",
  null
  
)

export default component.exports